import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { File } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';

@Injectable({
    providedIn: 'root',
})
export class FileApiService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    get(tenantId: string, branchId: string, internalName: string): Observable<File> {
        return this.http.get<File>(this.serviceUtils.getBaseUrl('file', tenantId, branchId) + `/${internalName}`);
    }

    upload(tenantId: string, branchId: string, blob: Blob, blobName: string): Observable<File> {
        const form = new FormData();
        form.append('file', blob, blobName);
        return this.http.post<File>(this.serviceUtils.getBaseUrl('file', tenantId, branchId, 'v2') + '/upload', form);
    }

    uploadMany(tenantId: string, branchId: string, files: { blob: Blob; blobName: string }[]): Observable<File[]> {
        const form = new FormData();
        for (const f of files) {
            form.append('files', f.blob, f.blobName);
        }
        return this.http.post<{ files: File[] }>(this.serviceUtils.getBaseUrl('file', tenantId, branchId, 'v2') + '/upload-many', form).pipe(
            map((s) => s.files),
        );
    }
}
